// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-content {\n  padding: 0.1rem;\n  height: 4rem;\n  overflow-y: auto;\n  word-wrap: break-word;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
